// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";

const hoverBlock = (rules: string) => () =>
    `
    transform: perspective(1px);
    &:hover{
        ${rules}
    }
`;

const hoverAnimations = {
    none: hoverBlock(""),
    grow: hoverBlock("transform: perspective(1px) scale(1.1);"),
    shrink: hoverBlock("transform: perspective(1px) scale(0.9);"),
    float: hoverBlock("transform: perspective(1px) translateY(-0.5em);"),
    // XNG-Changes
    bounceRight: hoverBlock(`
        @keyframes bounceright {
            from { transform: translateX(0); }
            to   { transform: translateX(3px); }
        }
        ${IconWrapper} {
            animation: bounceright .3s alternate ease infinite;
        }
    `),
    shoppingCart: hoverBlock(`
        @keyframes shoppingCart {
            0% {
                transform: rotate(-20deg);
                left: -8px;
            }
            25% {
                transform: rotate(-20deg);
                left: -5px;
            }
            50% {
                transform: rotate(-20deg);
                left: 0px;
            }
            55% {
                transform: rotate(0deg);
                left: 3px;
            }
            70% {
                transform: rotate(0deg);
                left: 3px;
            }
            100% {
                transform: rotate(0deg);
                left: 3px;
            }
        }
        ${IconWrapper} {
            animation: shoppingCart 1s alternate ease infinite;
        }
    `),
    vibration: hoverBlock(`
        @keyframes shake {
            0% {
                transform: translate(1px, 1px) rotate(0deg);
            }
            10% {
                transform: translate(-1px, -2px) rotate(-1deg);
            }
            20% {
                transform: translate(-3px, 0px) rotate(1deg);
            }
            30% {
                transform: translate(3px, 2px) rotate(0deg);
            }
            40% {
                transform: translate(1px, -1px) rotate(1deg);
            }
            50% {
                transform: translate(-1px, 2px) rotate(-1deg);
            }
            60% {
                transform: translate(-3px, 1px) rotate(0deg);
            }
            70% {
                transform: translate(3px, 1px) rotate(-1deg);
            }
            80% {
                transform: translate(-1px, -1px) rotate(1deg);
            }
            90% {
                transform: translate(1px, 2px) rotate(0deg);
            }
            100% {
                transform: translate(1px, -2px) rotate(-1deg);
            }
        }
        ${IconWrapper} {
            animation: shake 0.5s alternate ease infinite;
        }
    `),
};

export default hoverAnimations;
